import posthog from "posthog-js";
import { toastr } from "react-redux-toastr";
import { axiosBasic } from "../api/axios";
import moment from "moment";
import { messages } from "./messages";
import { WebStorage, WebStorageNames } from "../utils";
import { config } from '../api/endPoints';
const { S3Upload, Company } = config.REST_API;

export class Common {
  static getRecordSorted(record) {
    const me = this;
    if (record !== undefined) {
      const sorted = record.sort(function (firstValue, secondValue) {
        return me.compareValues(
          Number(firstValue.timeHr + "." + me.getFormated(firstValue.timeMin)),
          Number(secondValue.timeHr + "." + me.getFormated(secondValue.timeMin))
        );
      });
      return sorted;
    }
    return [];
  }
  static getFormated(value) {
    if (value < 10) {
      return "0" + Number(value);
    }
    return value;
  }
  static compareValues(firstValue, secondValue) {
    if (firstValue < secondValue) {
      return -1;
    }
    if (firstValue > secondValue) {
      return 1;
    }
    return 0;
  }
  static getDOBFormated(value) {
    const date = new Date(value);
    let Day = date.getDate();
    if (Day < 10) {
      Day = "0" + Day;
    }
    let Month = date.getMonth() + 1;
    if (Month < 10) {
      Month = "0" + Month;
    }
    const Year = date.getFullYear().toString().substring(2);
    return Day + "/ " + Month + "/ " + Year;
  }

  static setDateOfBirth(dob) {
    return moment(dob);
  }

  static getList(listLength) {
    let list = [];
    for (let element = 0; element < listLength; element++) {
      if (element !== 0)
        list.push({
          id: element,
          name: element,
        });
    }
    return list;
  }

  static showErrorMessage(error, title = "Error") {
    let errorMsg = error;
    const { error403, error404, error400 } = messages.validation;
    if (error.message) {
      errorMsg = error.message;
    }
    if (errorMsg === "Unexpected end of JSON input") {
      errorMsg = error404;
    }
    if (errorMsg === "Request failed with status code 400") {
      errorMsg = error400;
    }
    if (errorMsg === "Un-Authorized Access") {
      errorMsg = error403;
      this.clearUserInfo();
    }
    this.isIE9() ? alert(errorMsg) : toastr.error(title, errorMsg, { showCloseButton: true });
  }

  static showErrorMessageTextBox(error, title = "Error") {
    let errorMsg = error;
    if (error.message) {
      errorMsg = error.message;
    }
    toastr.message(title, errorMsg, { showCloseButton: true });
  }

  static showInfoMessage(message, title = "Information") {
    this.isIE9() ? alert(message) : toastr.info(title, message, { showCloseButton: true });
  }

  static showSuccessMessage(message, title = "Success") {
    this.isIE9() ? alert(message) : toastr.success(title, message, { showCloseButton: true });
  }

  static removeAllMessages() {
    toastr.removeByType("error");
    toastr.removeByType("success");
    toastr.removeByType("message");
  }

  //Todo:
  // static logErrors(
  //   errorMessage,
  //   url = window.location.href,
  //   lineNumber = 0,
  //   column = 0,
  //   errorObj = null,
  //   code = 0
  // ) {
  //   if (code === 404 && code === 401) {
  //     this.clearUserInfo();
  //   } else {
  //     AjaxService.post(config.REST_APIs.Exception.logError, {
  //       ErrorMessage: errorMessage.toString(),
  //       Url: url,
  //       LineNumber: lineNumber,
  //     });
  //   }
  // }
  static handleExceptions(Exception) {
    if (Exception.message === "Network Error") {
      this.isIE9()
        ? alert(Exception.message)
        : Common.showErrorMessage(Exception.message);
    } else if (Exception.message === "Unexpected end of JSON input") {
      this.isIE9()
        ? alert(Exception.message)
        : Common.showErrorMessage(Exception.message);
      this.clearUserInfo();
    } else if (Exception.message === "Request failed with status code 400") {
      this.isIE9()
        ? alert(Exception.message)
        : Common.showErrorMessage(Exception.message);
    } else {
      if (Exception.config && Exception.response.status === 404) {
        Common.logErrors(
          Exception.stack,
          Exception.config.url,
          null,
          null,
          null,
          Exception.response.status
        );
      } else if (Exception.response.status === 401) {
        this.isIE9()
          ? alert(Exception.message)
          : Common.showErrorMessage(Exception.message);
        this.clearUserInfo();
      }
      if (Exception.request) {
        Common.logErrors(Exception.stack, Exception.config.url);
        if (Exception.request.responseText !== "") {
          const response = JSON.parse(Exception.request.responseText);
          this.isIE9()
            ? alert(response.Message)
            : this.showErrorMessage(response.Message);
        } else {
          this.isIE9()
            ? alert(messages.Exception.exceptionMsg)
            : this.showErrorMessage(messages.Exception.exceptionMsg);
        }
      } else {
        this.isIE9()
          ? alert(Exception.message)
          : this.showErrorMessage(Exception.message);
        Common.logErrors(Exception.stack);
      }
    }
  }
  static clearUserInfo() {
    WebStorage.setLocalStore(WebStorageNames.UserInfo, null);
    WebStorage.setLocalStore(WebStorageNames.AuthInfo, null);
    window.location.reload(true);
  }

  // eslint-disable-next-line
  static isIE9 = () => {
    var wn = window.navigator,
      userAgent = wn.userAgent.toLowerCase(),
      storedName;
    // ie
    if (userAgent.indexOf("msie", 0) !== -1) {
      // var browserName = "ie";
      storedName = userAgent.match(/msie[ ]\d{1}/).toString();
      var version = storedName.replace(/msie[ ]/, "");

      // var browserOsVersion = browserName + version;
      return Number(version) === 9;
    }
  };
  static isFunction(functionToCheck) {
    return (
      functionToCheck &&
      {}.toString.call(functionToCheck) === "[object Function]"
    );
  }
}

export const countTotal = (name, arr) =>
  arr.reduce((total, amount) => amount[name] + total, 0);

export const checkDateFormat = (data) =>
  data === "" ? new Date() : new Date(data);

export const formatDate = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const getPreSignedUrl = (fileName, type) => {
  const dto = {
    fileName: fileName,
    type: type
  };
  return axiosBasic.post(S3Upload.GetUploadPreSignedUrl, dto);
};

export const updateCompanyLogo = (companyId, uploadedUrl) => {
  return axiosBasic.put(Company.UpdateCompanyLogo, {
    id: companyId,
    logoUrl: uploadedUrl
  });
};

export const uploadImgToS3 = (method, obj, file) => new Promise((resolve, reject) => {
  const url = obj.presignedUrl
  const xhr = new XMLHttpRequest();
  xhr.open(method, url);

  xhr.setRequestHeader('Content-Type', file.type);
  xhr.setRequestHeader('Cache-Control', 'no-cache');

  xhr.withCredentials = false; // Don't send cookies for S3 uploads

  xhr.onload = () => {
    console.log('S3 Upload Response:', {
      status: xhr.status,
      statusText: xhr.statusText,
      responseHeaders: xhr.getAllResponseHeaders(),
      responseText: xhr.responseText
    });

    if (xhr.status >= 200 && xhr.status < 300) {
      const finalUrl = url.split('?')[0]; // Remove query parameters
      resolve(finalUrl);
    } else {
      if (typeof posthog !== "undefined" && posthog.capture) {
        posthog.capture("s3Upload", {
          type: "exception",
          success: false,
          reason: `S3 upload failed. Status: ${xhr.status}`,
          status: xhr.status,
          statusText: xhr.statusText,
          responseText: xhr.responseText,
          responseHeaders: xhr.getAllResponseHeaders(),
        });
      }

      // Provide more specific error messages
      let errorMessage = `S3 Upload failed. Status: ${xhr.status}`;
      if (xhr.status === 403) {
        errorMessage = 'S3 Upload failed: Access denied (403). Check presigned URL validity and permissions.';
      } else if (xhr.status === 400) {
        errorMessage = 'S3 Upload failed: Bad request (400). Check file format and presigned URL.';
      } else if (xhr.status === 0) {
        errorMessage = 'S3 Upload failed: CORS error or network issue.';
      }

      reject(new Error(errorMessage));
    }
  };

  xhr.onerror = (error) => {
    if (typeof posthog !== "undefined" && posthog.capture) {
      posthog.capture("s3Upload", {
        type: "exception",
        success: false,
        reason: "Network error during S3 upload",
        error: error?.message ?? String(error),
      });
    }
    reject(new Error('Network error during S3 upload'));
  };

  xhr.ontimeout = () => {
    if (typeof posthog !== "undefined" && posthog.capture) {
      posthog.capture("s3Upload", {
        type: "exception",
        success: false,
        reason: "S3 upload timeout",
      });
    }
    reject(new Error('S3 upload timeout'));
  };

  // Log the request details before sending
  console.log('S3 Request Details:', {
    method,
    url,
    contentType: file.type,
    fileSize: file.size,
    fileName: file.name
  });

  xhr.send(file);
});

/**
 * PUT upload for company documents (PDF, Office, etc.).
 * Unlike images, file.type is often empty; S3 presigned URLs usually require an exact Content-Type match.
 * Prefer fileUrl/publicUrl from presigned response when the backend returns the final object URL.
 */
const DOCUMENT_EXT_TO_MIME = {
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  doc: "application/msword",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
};

export const uploadDocumentToS3 = (method, presignedObj, file) =>
  new Promise((resolve, reject) => {
    const url = presignedObj?.presignedUrl;
    if (!url || typeof url !== "string") {
      reject(new Error("Missing presigned URL for document upload."));
      return;
    }

    const name = file?.name || "";
    const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
    // Must match what the server included when generating the presigned URL; wrong type → 403 or silent mismatch.
    const signedContentType =
      presignedObj.contentType ||
      presignedObj.ContentType ||
      presignedObj.signedContentType ||
      presignedObj.SignedContentType;
    const contentType =
      (signedContentType && String(signedContentType).trim()) ||
      (file?.type && String(file.type).trim()) ||
      DOCUMENT_EXT_TO_MIME[ext] ||
      "application/octet-stream";

    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader("Content-Type", contentType);
    // Only set if backend included it in the signature / response; arbitrary Cache-Control often breaks SigV4.
    const cacheControl = presignedObj.cacheControl || presignedObj.CacheControl;
    if (cacheControl) {
      xhr.setRequestHeader("Cache-Control", String(cacheControl));
    }
    xhr.withCredentials = false;

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const stripped = url.split("?")[0];
        const finalUrl =
          presignedObj.fileUrl ||
          presignedObj.FileUrl ||
          presignedObj.publicUrl ||
          presignedObj.PublicUrl ||
          presignedObj.url ||
          presignedObj.Url ||
          stripped;
        resolve(String(finalUrl).trim());
      } else {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("s3DocumentUpload", {
            type: "exception",
            success: false,
            reason: `S3 document upload failed. Status: ${xhr.status}`,
            status: xhr.status,
            statusText: xhr.statusText,
            responseText: xhr.responseText,
          });
        }
        let errorMessage = `S3 document upload failed. Status: ${xhr.status}`;
        if (xhr.status === 403) {
          errorMessage =
            "Document upload failed (403). Check presigned URL or Content-Type matches what the server signed.";
        } else if (xhr.status === 400) {
          errorMessage = "Document upload failed (400). Invalid request or URL expired.";
        } else if (xhr.status === 0) {
          errorMessage = "Document upload failed: network or CORS issue.";
        }
        reject(new Error(errorMessage));
      }
    };

    xhr.onerror = () => {
      if (typeof posthog !== "undefined" && posthog.capture) {
        posthog.capture("s3DocumentUpload", {
          type: "exception",
          success: false,
          reason: "Network error during document upload",
        });
      }
      reject(new Error("Network error during document upload"));
    };

    xhr.ontimeout = () => {
      reject(new Error("Document upload timed out"));
    };

    xhr.send(file);
  });

export const getSubString = (str, key) => {
  const index = str.indexOf(key);
  return str.substr(0, index);
};

/**
 * Formats and displays MaxAbsent error messages from skippedDatesWithMessages
 * @param {Object} skippedDatesWithMessages - Dictionary of date strings to error messages
 * @returns {string} - Formatted error message string
 */
export const formatMaxAbsentErrors = (skippedDatesWithMessages) => {
  if (!skippedDatesWithMessages || typeof skippedDatesWithMessages !== 'object') {
    return null;
  }

  const entries = Object.entries(skippedDatesWithMessages);
  if (entries.length === 0) {
    return null;
  }

  // Format each date and its error message
  const formattedErrors = entries.map(([dateStr, message]) => {
    try {
      const date = new Date(dateStr);
      const formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
      return `${formattedDate}: ${message}`;
    } catch (e) {
      // If date parsing fails, just use the date string as-is
      return `${dateStr}: ${message}`;
    }
  });

  return formattedErrors.join('\n');
};

/**
 * Displays MaxAbsent errors to the user
 * @param {Object} skippedDatesWithMessages - Dictionary of date strings to error messages
 * @param {string} title - Title for the error message (default: "MaxAbsent Limit Reached")
 */
export const showMaxAbsentErrors = (skippedDatesWithMessages, title = "MaxAbsent Limit Reached") => {
  const formattedMessage = formatMaxAbsentErrors(skippedDatesWithMessages);
  if (formattedMessage) {
    Common.showErrorMessage(formattedMessage, title);
  }
};